/* LinksRenderer.js */

"use strict";
const Registrations = require("../../../../../../../RegistrationNamespaces");
// const _ = require('lodash');

class LinksRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("links-column");
        this._rootElem.component = this._model;

        this._logsIcon = document.createElement("actionable-icon-gl");
        this._logsIcon.dataset.icon = "common.log_link";
        this._logsIcon.setAttribute("title", "Logs");

        this._targetResultsIcon = document.createElement("actionable-icon-gl");
        this._targetResultsIcon.dataset.icon = "common.target_link";
        this._targetResultsIcon.setAttribute("title", "Targets");

        this._resultLinkIcon = document.createElement("actionable-icon-gl");
        this._resultLinkIcon.dataset.icon = "common.results_link";
        this._resultLinkIcon.setAttribute("title", "Results");

        this._disabledLogsIcon = document.createElement("actionable-icon-gl");
        this._disabledLogsIcon.dataset.icon = "common.log_link";
        this._disabledLogsIcon.setAttribute("title", "Logs");
        this._disabledLogsIcon.dataset.disabled = "true";

        this._disabledTargetResultsIcon = document.createElement("actionable-icon-gl");
        this._disabledTargetResultsIcon.dataset.icon = "common.target_link";
        this._disabledTargetResultsIcon.setAttribute("title", "Targets");
        this._disabledTargetResultsIcon.dataset.disabled = "true";

        this._disabledResultLinkIcon = document.createElement("actionable-icon-gl");
        this._disabledResultLinkIcon.dataset.icon = "common.results_link";
        this._disabledResultLinkIcon.setAttribute("title", "Results");
        this._disabledResultLinkIcon.dataset.disabled = "true";

        this._registerListeners();
        this.render();
    }

    /* ******************************************
    /* START PRIVATE COMPONENT RENDERER METHODS
    /* ****************************************** */
    _shutdown() {
        return new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();
            this._logsIcon.remove();
            this._logsIcon = undefined;
            this._targetResultsIcon.remove();
            this._targetResultsIcon = undefined;
            this._resultLinkIcon.remove();
            this._resultLinkIcon = undefined;
            this._disabledLogsIcon.remove();
            this._disabledLogsIcon = undefined;
            this._disabledTargetResultsIcon.remove();
            this._disabledTargetResultsIcon = undefined;
            this._disabledResultLinkIcon.remove();
            this._disabledResultLinkIcon = undefined;
            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            resolve();
        });
    }

    _registerListeners() {
        if (this._targetResultsIcon) {
            this._targetResultsIcon.addEventListener(
                "click",
                (this._onClickTargetsIcon = this._onClickTargetsIcon.bind(this))
            );
        }
        this._logsIcon.addEventListener(
            "click",
            (this._onClickLogsIcon = this._onClickLogsIcon.bind(this))
        );
        if (this._resultLinkIcon) {
            this._resultLinkIcon.addEventListener(
                "click",
                (this._onClickResultLinkIcon = this._onClickResultLinkIcon.bind(this))
            );
        }
        this._model.on("Links", (this._onLinks = this._onLinks.bind(this)));
    }

    _unregisterListeners() {
        if (this._targetResultsIcon) {
            this._targetResultsIcon.removeEventListener("click", this._onClickTargetsIcon);
        }
        this._logsIcon.removeEventListener("click", this._onClickLogsIcon);
        if (this._resultLinkIcon) {
            this._resultLinkIcon.removeEventListener("click", this._onClickResultLinkIcon);
        }
        this._model.removeAllListeners("Links");
    }

    _switchToTargetResultsView() {
        this._model._gameEditor.setActiveView(
            Registrations.WTE_VIEW_TARGET_RESULTS,
            [
                {
                    value: {
                        fqn: Registrations.WTE_VIEW_HISTORY,
                    },
                    content: "Schedule History",
                    left: {
                        arrow: {
                            direction: "left",
                        },
                    },
                },
            ],
            {
                triggerEntity: this._model.getValue(),
            }
        );
    }

    _switchToLogView() {
        this._model._gameEditor.setActiveView(
            Registrations.WTE_VIEW_LOGS,
            [
                {
                    value: {
                        fqn: Registrations.WTE_VIEW_HISTORY,
                    },
                    content: "Schedule History",
                    left: {
                        arrow: {
                            direction: "left",
                        },
                    },
                },
            ],
            {
                triggerEntity: this._model.getValue(),
            }
        );
    }

    /* *****************************************
    /* END PRIVATE COMPONENT RENDERER METHODS
    /* START PUBLIC COMPONENT RENDERER METHODS
    /* ***************************************** */
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        this._setLinks(this._model.getLinks());
        return Promise.resolve();
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /* *****************************************
    /* END COMPONENT RENDERER METHODS
    /* START HANDLER METHODS
    /* ***************************************** */

    _onLinks(newVal) {
        this._setLinks(newVal);
    }

    _onClickLogsIcon() {
        this._switchToLogView();
    }

    _onClickTargetsIcon() {
        this._switchToTargetResultsView();
    }

    _onClickResultLinkIcon() {
        this._resultLinkIcon.removeEventListener("click", this._onClickResultLinkIcon);
        this._resultLinkIcon.classList.add("disabled");
        this._model
            .downloadWorkReport()
            .finally(() => {
                this._resultLinkIcon.addEventListener(
                    "click",
                    (this._onClickResultLinkIcon = this._onClickResultLinkIcon.bind(this))
                );
                this._resultLinkIcon.classList.remove("disabled");
            })
            .catch((err) => {
                if (err && err.errorCode === "NotAuthorized") {
                    this._model._modalUserFeedback.displayError({
                        errorMsg: "Sorry, you don’t have the permissions to perform this action.",
                        errorCode: "SyntaxError",
                        title: "Error",
                    });
                } else if (err && err.errorCode === "WorkErrorRetrieval") {
                    this._model._modalUserFeedback.displayError({
                        errorMsg: "Cannot retrieve the selected workEntity report",
                        errorCode: "SyntaxError",
                        title: "Error",
                    });
                } else {
                    this._model._logger.warn({error: err}, "_onClickResultLinkIcon() - Error");
                }
            });
    }

    /* *****************************************
    /* END HANDLER METHODS
    /* START PRIVATE API METHODS
    /* ***************************************** */

    _setLinks(newVal) {
        this._rootElem.innerHTML = "";
        //test if work is done so actions can be performed
        const actionsReady =
            newVal.workId && newVal.status !== "QUEUED" && newVal.status !== "RUNNING";
        if (
            this._model._triggerType.getSolution() === "System" &&
            this._model._triggerType.getDisplayName() === "Cisco API Console"
        ) {
            if (actionsReady) {
                this._rootElem.appendChild(this._logsIcon);
            } else {
                this._rootElem.appendChild(this._disabledLogsIcon);
            }
        } else if (actionsReady) {
            this._rootElem.appendChild(this._logsIcon);
            this._rootElem.appendChild(this._targetResultsIcon);
            this._rootElem.appendChild(this._resultLinkIcon);
        } else {
            if (newVal.status !== "QUEUED") {
                this._rootElem.appendChild(this._logsIcon);
            } else {
                this._rootElem.appendChild(this._disabledLogsIcon);
            }

            this._rootElem.appendChild(this._disabledTargetResultsIcon);
            this._rootElem.appendChild(this._disabledResultLinkIcon);
        }
    }

    /* *****************************************
    /* END PRIVATE API METHODS
    /* ***************************************** */
}

module.exports = LinksRenderer;
